/**
 * This is for Embed integrations
 */

import { createAxiosInstance } from '@speechki-frontend/shared/axios';

import { retry } from '@speechki-frontend/shared/helpers/functions';

const URL = process.env.VUE_APP_HERMES_API_URL;

const axios = createAxiosInstance(URL, { enableGuestAccess: true, rejectOn5xx: true });

export const fetchAvailableTransitions = () => {
    return axios.get('/api/v1/orders/available_transitions/');
};

export const changeState = (order, state) => {
    return axios.post(`/api/v1/orders/orders/guest_change_state/${state}/`);
};

export const fetchOrderShort = id => {
    return axios.get(`/api/v1/orders/orders/${id}/short/`);
};

export const checkEditorAvailable = async () => {
    return retry(
        () => axios.get('/api/v2/orders/is_editor_available/'),
        () => {},
        5,
        500,
        true
    );
};
